module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/custom-accesibility-icon-1410a98abacd8cbc40607907b5a9a7cb.png";